/** Runtime DDL for platform rag_* tables. Drizzle reference: ./rag-ingest-schema-reference.ts */
export const RAG_SYSTEM_SCHEMA_STATEMENTS = [
  `CREATE TABLE IF NOT EXISTS rag_corpora (
        id TEXT PRIMARY KEY,
        corpus TEXT NOT NULL,
        visibility_scope TEXT NOT NULL,
        owner_user_id TEXT,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        title TEXT NOT NULL,
        description TEXT,
        allow_external_providers BOOLEAN NOT NULL DEFAULT false,
        retention_days INTEGER,
        metadata JSONB NOT NULL DEFAULT '{}'::jsonb
    )`,
  `CREATE UNIQUE INDEX IF NOT EXISTS idx_rag_corpora_scope ON rag_corpora (corpus, visibility_scope, COALESCE(owner_user_id, ''))`,
  `CREATE TABLE IF NOT EXISTS rag_sources (
        id TEXT PRIMARY KEY,
        corpus TEXT NOT NULL,
        visibility_scope TEXT NOT NULL,
        owner_user_id TEXT,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        storage_id TEXT NOT NULL,
        source_key TEXT NOT NULL,
        source_title TEXT NOT NULL,
        mime_type TEXT NOT NULL,
        byte_size BIGINT NOT NULL,
        source_checksum TEXT NOT NULL,
        convert_provider TEXT NOT NULL,
        convert_status TEXT NOT NULL,
        markdown TEXT NOT NULL DEFAULT '',
        text TEXT NOT NULL DEFAULT '',
        warnings JSONB NOT NULL DEFAULT '[]'::jsonb,
        metadata JSONB NOT NULL DEFAULT '{}'::jsonb
    )`,
  `CREATE UNIQUE INDEX IF NOT EXISTS idx_rag_sources_scope_key ON rag_sources (corpus, visibility_scope, COALESCE(owner_user_id, ''), source_key)`,
  `CREATE INDEX IF NOT EXISTS idx_rag_sources_checksum ON rag_sources (corpus, source_checksum)`,
  `CREATE TABLE IF NOT EXISTS rag_sections (
        id TEXT PRIMARY KEY,
        corpus TEXT NOT NULL,
        visibility_scope TEXT NOT NULL,
        owner_user_id TEXT,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        source_id TEXT NOT NULL,
        section_index INTEGER NOT NULL,
        section_path JSONB NOT NULL DEFAULT '[]'::jsonb,
        title TEXT,
        depth INTEGER NOT NULL,
        page_start INTEGER,
        page_end INTEGER,
        char_start INTEGER NOT NULL,
        char_end INTEGER NOT NULL
    )`,
  `CREATE INDEX IF NOT EXISTS idx_rag_sections_source ON rag_sections (source_id, section_index)`,
  `CREATE TABLE IF NOT EXISTS rag_chunks (
        id TEXT PRIMARY KEY,
        corpus TEXT NOT NULL,
        visibility_scope TEXT NOT NULL,
        owner_user_id TEXT,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        source_id TEXT NOT NULL,
        section_id TEXT,
        chunk_index INTEGER NOT NULL,
        chunk_text TEXT NOT NULL,
        lexical_text TEXT NOT NULL,
        embedding vector(1536),
        page_start INTEGER,
        page_end INTEGER,
        chunk_checksum TEXT NOT NULL,
        metadata JSONB NOT NULL DEFAULT '{}'::jsonb
    )`,
  `CREATE INDEX IF NOT EXISTS idx_rag_chunks_scope ON rag_chunks (corpus, visibility_scope, COALESCE(owner_user_id, ''))`,
  `CREATE INDEX IF NOT EXISTS idx_rag_chunks_source ON rag_chunks (source_id, chunk_index)`,
  `CREATE TABLE IF NOT EXISTS rag_ingest_jobs (
        id TEXT PRIMARY KEY,
        corpus TEXT NOT NULL,
        visibility_scope TEXT NOT NULL,
        owner_user_id TEXT,
        created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        workflow_id TEXT NOT NULL,
        source_id TEXT NOT NULL,
        status TEXT NOT NULL,
        stage TEXT NOT NULL,
        provider_trace JSONB NOT NULL DEFAULT '{}'::jsonb,
        metrics JSONB NOT NULL DEFAULT '{}'::jsonb,
        error TEXT,
        started_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        completed_at TIMESTAMPTZ
    )`,
  `CREATE UNIQUE INDEX IF NOT EXISTS idx_rag_ingest_jobs_workflow ON rag_ingest_jobs (workflow_id)`,
  `CREATE INDEX IF NOT EXISTS idx_rag_ingest_jobs_source ON rag_ingest_jobs (source_id, started_at DESC)`,
  `CREATE TABLE IF NOT EXISTS rag_operation_metrics (
        id TEXT PRIMARY KEY,
        app_id TEXT NOT NULL,
        corpus TEXT NOT NULL,
        visibility_scope TEXT NOT NULL,
        owner_user_id TEXT,
        operation TEXT NOT NULL,
        job_id TEXT,
        workflow_id TEXT,
        source_id TEXT,
        metric_name TEXT NOT NULL,
        metric_value DOUBLE PRECISION NOT NULL,
        unit TEXT,
        metadata JSONB NOT NULL DEFAULT '{}'::jsonb,
        recorded_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
    )`,
  `CREATE INDEX IF NOT EXISTS idx_rag_operation_metrics_scope ON rag_operation_metrics (corpus, visibility_scope, COALESCE(owner_user_id, ''), recorded_at DESC)`,
  `CREATE INDEX IF NOT EXISTS idx_rag_operation_metrics_operation ON rag_operation_metrics (operation, metric_name, recorded_at DESC)`,
] as const;
